<section1 [sectionIcon]="sectionIcon"
          [isCurrent]="isCurrent"
          [sectionTitle]="sectionTitle">

    @if(!disableCollection) {
    <div sectionAction>
        @if (displayDeliveryTypeToggle) {
        <action class="button-inline"
                (click)="toggleDeliverySelection()"
                [status]="checkout.resetShippingMethodStatus">
            <span class="p1">
                {{'Switch to' | translate}}&nbsp;{{deliveryToggleLabel}}
            </span>
        </action>
        }
    </div>
    }

    <checkout-expandable [expandableOff]="expandableOff"
                         sectionBody
                         [expandableId]="expandableId">

        <div expandableTitle>
            @if (isShipping) {
            <address-short [address]="address"></address-short>
            }
            @if (isCollection) {
            <checkout-store-pickup-store [modelId]="checkout.selfCollectStoreId"></checkout-store-pickup-store>
            }
        </div>
        <div expandableBody>

            @if (isCollection) {
            <checkout-store-pickup></checkout-store-pickup>
            }

            @if (isShipping) {
            <div>
                <checkout-address class="block"
                                  [data]="address">
                </checkout-address>
                <result duration="permanent"
                        [status]="saveAdressStatus"></result>
                @if (!checkout.isSamples) {
                <newsletter-checkboxes class="block"
                                       source="checkout"
                                       [email]="checkout.email"
                                       [checkoutData]="checkout.data"
                                       [beforeSubmitSubject]="checkout.beforeSubmitSubject"
                                       [variant]="'checkout'"></newsletter-checkboxes>
                }
                <checkout-shipping-methods class="block"></checkout-shipping-methods>
                @if (!checkout.isFree) {
                <action (click)="continue()"
                        class="button w-12 m-t-9"
                        [class.busy]="isBusy">
                    {{ 'Continue to payment' | translate }}
                </action>
                }
                @if (saveError) {
                <p class="p2 col-2 p-t-2 p-b-2">{{saveError}}</p>
                }
                @if (checkout.isFree) {
                <checkout-submit class="block m-t-9 p-t-7 b-t b-col-4"
                                 [paymentMethodCode]="checkout.paymentMethodCode"></checkout-submit>
                }
            </div>
            }

        </div>
    </checkout-expandable>
</section1>
